<template lang="html">

    <aside class="accesos">

        <article class="titulados">

          <a :href="$t('portalalumno')" class="enlace-cover"></a>

          <div class="top column-center">
            <h2>Titulados</h2>
          </div>

          <div class="bottom column-center">
            <h2>Accede al mercado laboral</h2>
          </div>

        </article>
        <article class="empresas">
          <a :href="$t('portalempresas')" class="enlace-cover"></a>
          <div class="top column-center">
            <h2>Empresas</h2>
          </div>

          <div class="bottom column-center">
            <h2>Recluta el mejor talento</h2>
          </div>
        </article>


      </aside>
  
  </template>
  
  <script lang="js">
    export default {
      name: 'accesos',
    }
  </script>



// WEBPACK FOOTER //
// src/components/parts/accesos.vue